<template>
  <div class="top-nav-bar">
    <div class="center-v-absolute bar-title">
      <h4>{{ slideInfo.name }} / Assignee: {{ slideInfo.assignee }} / {{ readOnly }}</h4>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useConfigStore } from '@/store/config';

const store = useConfigStore();

const slideInfo = computed(() => store.slideInfo || {});
const isReadOnly = computed(() => store.isReadOnly);

const readOnly = computed(() => (isReadOnly.value ? 'Read Only (Not Assigned)' : 'Read & Write'));
</script>

<style lang="scss" scoped>
@use '@/assets/scss/common/alignment' as *;
.top-nav-bar {
  position: fixed;
  z-index: 2;
  width: 100%;
  height: 70px;
  background-color: #1045AC;
  // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 1);
}
.bar-title {
  color: #FFFFFF;
  margin-left: 40px;
  letter-spacing: 1px
}
</style>
